import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class ReverformService {

  constructor(private api: ApiService) { }

  findByInviteToken(token: string): Observable<any> {
    return this.api.get('revert/' + token);
}

submitForm(revertToken, params): Observable<any[]> {
    return this.api.post('revert/' + revertToken, params);
}

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/core/services/reverform.service.ts